import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — corner railing. Two half-length railing runs along +X and +Z
// meet at a corner post at the tile centre, joining half-length straight
// railing tiles into an L. Same styling as railing-straight: matte-black
// frame, glass infill, handrail at 1.0 m.
const BLACK = "#2e2e30";
const GLASS = "#9fc4d4";

export const railingCorner = defineModel({
  id: "railing-corner",
  batchId: "modern",
  name: "Railing corner",
  tags: ["modern", "interior", "outdoor", "structure", "railing"],
  summary: "An L-corner glass railing joining runs along +X and +Z.",
  description:
    "The corner railing of the Modern Living kit: two half-length runs " +
    "along +X and +Z meeting at a corner post at the tile centre, styled " +
    "like railing-straight (matte-black frame, glass infill, handrail at " +
    "1.0 m). Rotate 90 degrees to orient the corner.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    return [
      // Corner post at the tile centre, end posts at the tile edges.
      { geometry: new THREE.BoxGeometry(0.05, 1.0, 0.05), color: BLACK, position: [0, 0.5, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 1.0, 0.05), color: BLACK, position: [0.475, 0.5, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 1.0, 0.05), color: BLACK, position: [0, 0.5, 0.475] },
      // Handrails at 1.0 m along +X and +Z.
      { geometry: new THREE.BoxGeometry(0.5, 0.05, 0.06), color: BLACK, position: [0.25, 1.0, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.05, 0.5), color: BLACK, position: [0, 1.0, 0.25] },
      // Bottom rails.
      { geometry: new THREE.BoxGeometry(0.4, 0.04, 0.05), color: BLACK, position: [0.24, 0.08, 0] },
      { geometry: new THREE.BoxGeometry(0.05, 0.04, 0.4), color: BLACK, position: [0, 0.08, 0.24] },
      // Glass infill panels.
      { geometry: new THREE.BoxGeometry(0.4, 0.86, 0.02), color: GLASS, position: [0.24, 0.53, 0] },
      { geometry: new THREE.BoxGeometry(0.02, 0.86, 0.4), color: GLASS, position: [0, 0.53, 0.24] },
    ];
  },
  animations: [],
});
